import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Goggles() {
  const tilt = useRef(null);

  useEffect(() => {
    const el = tilt.current;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!el || reduced || !fine) return undefined;
    const onMove = (event) => {
      const rect = el.getBoundingClientRect();
      const dx = (event.clientX - (rect.left + rect.width / 2)) / window.innerWidth;
      const dy = (event.clientY - (rect.top + rect.height / 2)) / window.innerHeight;
      el.style.transform = `rotateX(${(-dy * 16).toFixed(2)}deg) rotateY(${(dx * 20).toFixed(2)}deg)`;
    };
    const onLeave = () => {
      el.style.transform = "";
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseleave", onLeave);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  return (
    <div className="lost-float">
      <div className="lost-tilt" ref={tilt}>
        <svg className="lost-mark" viewBox="-6 -6 112 112" aria-hidden="true" focusable="false">
          <path d="M2 46 H98" stroke="#ff3df2" strokeWidth="8" strokeLinecap="round" />
          <rect x="8" y="26" width="38" height="42" rx="14" fill="#07060b" stroke="#f3f0ff" strokeWidth="7" />
          <rect x="54" y="26" width="38" height="42" rx="14" fill="#07060b" stroke="#f3f0ff" strokeWidth="7" />
          <clipPath id="lost-lenses">
            <rect x="12" y="30" width="30" height="34" rx="10" />
            <rect x="58" y="30" width="30" height="34" rx="10" />
          </clipPath>
          <g clipPath="url(#lost-lenses)">
            <rect className="wash" x="0" y="30" width="100" height="34" fill="#3dd8ff" />
            <g className="glance">
              <circle cx="27" cy="47" r="4.2" fill="#c6ff3d" />
              <circle cx="73" cy="47" r="4.2" fill="#c6ff3d" />
            </g>
            <rect className="scan" x="0" y="38" width="100" height="8" fill="#c6ff3d" />
          </g>
          <path d="M44 66 Q50 74 56 66" stroke="#f3f0ff" strokeWidth="5" fill="none" />
        </svg>
      </div>
    </div>
  );
}

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="lost">
      <Goggles />
      <p className="lbl">{"// 404 — "}{t("notFound.title")}</p>
      <h1 className="lost-code glitch" data-t="404">404</h1>
      <p className="lost-lead">{t("notFound.lead")}</p>
      <p className="lost-sub">{t("notFound.body")}</p>
      <Link className="btn p" to="/">{t("notFound.home")}</Link>
    </div>
  );
}
